import { create } from "zustand";

import type {
  PaymentEventProperties,
  UserProgressionStateModel,
} from "@/api/generated/models";

export interface ActiveProgressionStore {
  activeProgression: UserProgressionStateModel | null;
  checkoutPaymentProperties: Record<string, PaymentEventProperties | null>;
  setActiveProgression: (
    activeProgression: UserProgressionStateModel | null,
  ) => void;
  setCheckoutPaymentProperties: (
    clinicRequestId: string,
    properties: PaymentEventProperties,
  ) => void;
  clearCheckoutPaymentProperties: (clinicRequestId: string) => void;
}

export const useActiveProgressionStore = create<ActiveProgressionStore>()(
  (set) => ({
    activeProgression: null,
    checkoutPaymentProperties: {},
    setActiveProgression: (activeProgression) => set({ activeProgression }),
    setCheckoutPaymentProperties: (clinicRequestId, properties) =>
      set((state) => ({
        checkoutPaymentProperties: {
          ...state.checkoutPaymentProperties,
          [clinicRequestId]: properties,
        },
      })),
    clearCheckoutPaymentProperties: (clinicRequestId) =>
      set((state) => ({
        checkoutPaymentProperties: {
          ...state.checkoutPaymentProperties,
          [clinicRequestId]: null,
        },
      })),
  }),
);
